import { Controller, useFormContext } from 'react-hook-form';
import { RadioCardGroup, type RadioCardOption } from '../components/RadioCardGroup';
import type { SignupFormValues } from '../schema';

type TipoPerfil = SignupFormValues['tipoPerfil'];

const OPTIONS: ReadonlyArray<RadioCardOption<TipoPerfil>> = [
  { value: 'EMPRESARIO', label: 'Empresário' },
  { value: 'EXECUTIVO', label: 'Executivo' },
  { value: 'PROFISSIONAL', label: 'Profissional' },
  { value: 'CONSULTOR', label: 'Consultor' },
  { value: 'INVESTIDOR', label: 'Investidor' },
  { value: 'MENTOR', label: 'Mentor' },
];

export const Step04TipoPerfil = () => {
  const {
    control,
    formState: { errors },
  } = useFormContext<SignupFormValues>();

  return (
    <Controller
      control={control}
      name="tipoPerfil"
      render={({ field }) => (
        <RadioCardGroup<TipoPerfil>
          label="Como você se identifica"
          value={field.value}
          onChange={field.onChange}
          options={OPTIONS}
          columns={3}
          errorMessage={errors.tipoPerfil?.message}
        />
      )}
    />
  );
};
